
import { IStuNhomLopActionTypes } from "../../action-types/category/IStuNhomLopActions";
import { IStuNhomLopReducer } from "../../reducer-model/category/IStuNhomLopReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IStuNhomLopReducer = {
  status: eReducerStatusBase.is_not_initialization,
  nhomLops: [],
  nam_hoc: "",
  hoc_ky: 0,
  nhomLopSelectedIds: [],
  isShowPhanTuDongModal: false,
  filter: {
    id_he: 0,
    khoa_hoc: 0,
    id_chuyen_nganh: 0
  },
  phanNhomTuDongData: {
    step: 1,
    lopSelecteds: [],
    so_sv_moi_nhom: 0,
    is_chia_deu_gioi_tinh: true,
    is_chia_deu_theo_ten: true,
    nhomLops: [],
    quy_tac_dat_ten: "ghep_ten",
    so_lop_moi_nhom: 1
  },
  isShowEditModal: false
};
export const nhomLopReducer = (
  state: IStuNhomLopReducer = iniState,
  action: IStuNhomLopActionTypes
): IStuNhomLopReducer => {
  switch (action.type) {
    case "NHOM_LOP_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        nam_hoc: action.payload.nam_hoc,
        hoc_ky: action.payload.hoc_ky,
      };
    case "NHOM_LOP_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nhomLops: action.payload,
        nhomLopSelectedIds: []
      };
    case "NHOM_LOP_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_LOP_CHANGE_SELECTED_IDS":
      return {
        ...state,
        nhomLopSelectedIds: action.payload
      };
    case "NHOM_LOP_SHOW_PHAN_NHOM_TU_DONG_MODAL":
      return {
        ...state,
        isShowPhanTuDongModal: action.payload,
        phanNhomTuDongData: {
          step: 1,
          lopSelecteds: [],
          so_sv_moi_nhom: 0,
          is_chia_deu_gioi_tinh: false,
          is_chia_deu_theo_ten: false,
          nhomLops: [],
          quy_tac_dat_ten: "tu_tang",
          so_lop_moi_nhom: 1
        }
      }
    case "NHOM_LOP_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload
      }
    case "NHOM_LOP_UPDATE_PHAN_NHOM_TU_DONG_DATA":
      return {
        ...state,
        phanNhomTuDongData: action.payload
      }
    case "NHOM_LOP_PREVIEW_PHAN_NHOM_TU_DONG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading
      }
    case "NHOM_LOP_PREVIEW_PHAN_NHOM_TU_DONG_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        phanNhomTuDongData: {
          ...state.phanNhomTuDongData,
          nhomLops: action.payload
        }
      }
    case "NHOM_LOP_PREVIEW_PHAN_NHOM_TU_DONG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      }
    case "NHOM_LOP_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      }
    case "NHOM_LOP_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_SAVE_PHAN_NHOM_TU_DONG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_SAVE_PHAN_NHOM_TU_DONG_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowPhanTuDongModal: false
      }
    case "NHOM_LOP_SAVE_PHAN_NHOM_TU_DONG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "NHOM_LOP_SHOW_EIDT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        nhomLopEditing: action.payload
      }
    case "NHOM_LOP_CLOSE_EIDT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        nhomLopEditing: undefined,
      }
    case "NHOM_LOP_UPDATE_CA_HOC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_UPDATE_CA_HOC_SUCCESS":
      let newNhomLops = [...state.nhomLops];
      action.payload.forEach(x => {
        const id = x.id;
        const index = newNhomLops.findIndex(s => s.id === id);
        if (index !== -1) {
          newNhomLops[index] = { ...newNhomLops[index], ...x };
        }
      })
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nhomLops: newNhomLops
      }
    case "NHOM_LOP_UPDATE_CA_HOC_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_UPDATE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_UPDATE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        isShowEditModal: false,
        nhomLopEditing: undefined,
        nhomLops: [...state.nhomLops.map(x => {
          if (x.id === action.payload.id) {
            return {
              ...x,
              ...action.payload,
              // Update API có thể trả về object không đầy đủ field view-model,
              // nên luôn giữ lại ca_hoc_ky_truoc trên grid để tránh nhảy sai "Sáng".
              ca_hoc_ky_truoc: x.ca_hoc_ky_truoc
            }
          }
          return { ...x };
        })]
      }
    case "NHOM_LOP_UPDATE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_COPY_NHON_LOP_TU_KY_TRUOC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_COPY_NHON_LOP_TU_KY_TRUOC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      }
    case "NHOM_LOP_COPY_NHON_LOP_TU_KY_TRUOC_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_GHEP_CAP_TU_DONG_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_GHEP_CAP_TU_DONG_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      }
    case "NHOM_LOP_GHEP_CAP_TU_DONG_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_INSERT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_INSERT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
        nhomLopEditing: undefined
      }
    case "NHOM_LOP_INSERT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    case "NHOM_LOP_CREATE_FROM_CTDT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      }
    case "NHOM_LOP_CREATE_FROM_CTDT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      }
    case "NHOM_LOP_CREATE_FROM_CTDT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      }
    default:
      return state;
  }
};
